import React, { Fragment } from "react";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Logout from "./Auth/Logout";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton  from "@mui/material/ListItemButton";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CommuteIcon from "@mui/icons-material/Commute";
import BuildIcon from "@mui/icons-material/Build";
import GroupIcon from "@mui/icons-material/Group";
import SettingsIcon from "@mui/icons-material/Settings";
import DeblurIcon from '@mui/icons-material/Deblur';
import Clock from "./Clock/Clock";
import { Link } from "react-router-dom";
import { useAuthDataContext, UserRoles } from "./AuthDataProvider";
import { styled,  Theme, CSSObject } from "@mui/material/styles";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import MuiDrawer from "@mui/material/Drawer";
const drawerWidth = 240;

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar =
  styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
  }) <
  AppBarProps >
  (({ theme, open }) => ({
    background: "#EC32C5",
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      background: "#EC32C5",
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    }),
  }));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));


export default function Naviagtion() {
  const { user } = useAuthDataContext();

  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <AppBar
        position="fixed"
        open={open}
      >
        <Toolbar>
          {!open && user ? 
            (<IconButton onClick={handleDrawerOpen}>
                <ChevronRightIcon />
              </IconButton>
            ):null
          }
          <Typography
            variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}
            
          >
            FLEET WEB
          </Typography>
            

          {/* ------ ADD BANNER GREETINGS HERE ------ */}
          <Typography
            variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}
          >
            <Clock/>
            
            {/* Happy Holidays {user?.user_details.first}! */}
          </Typography>
          {/* ------ END OF BANNER GREETING ------ */}

          <div>{user?.user_details.name}</div>
          {user ? <Logout /> : null}
        </Toolbar>
      </AppBar>
      {user ? (
        <Drawer
          variant="permanent"
          
          open={open}
        >
          <DrawerHeader>
            <Typography>Some more fleetin</Typography>
            {open ? (
              <IconButton onClick={handleDrawerClose}>
                <ChevronLeftIcon />
              </IconButton>
            ) : (
              <IconButton onClick={handleDrawerOpen}>
                <ChevronRightIcon />
              </IconButton>
            )}
          </DrawerHeader>
          <Divider />
          {user ? (
            <List>
              <div>
                <Link to="/" style={{ color: "white", textDecoration: "none" }}>
                  <ListItem>
                  <ListItemButton>
                    <ListItemIcon>
                      <DashboardIcon />
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                  </ListItemButton>
                  </ListItem>
                </Link>
                {user?.roles.includes(UserRoles.firmware) ||
                user?.roles.includes(UserRoles.support) ? (
                  <a
                    href="https://fleetweb.alertlabs.com/toolserver/index"
                    rel="noopener noreferrer"
                    target="_blank"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    <ListItem>
                    <ListItemButton>
                      <ListItemIcon>
                        <BuildIcon />
                      </ListItemIcon>
                      <ListItemText primary="Tool Server" />
                      </ListItemButton>
                    </ListItem>
                  </a>
                ) : null}
                <Link
                  to="/fleet"
                  style={{ color: "white", textDecoration: "none" }}
                >
                  <ListItem>
                  <ListItemButton>
                    <ListItemIcon>
                      <CommuteIcon />
                    </ListItemIcon>
                    <ListItemText primary="Fleet Management" />
                    </ListItemButton>
                  </ListItem>
                </Link>
                {user?.roles.includes(UserRoles.admin) ? (
                  <Link
                    to="/applicationusers"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    <ListItem>
                    <ListItemButton>
                      <ListItemIcon>
                        <GroupIcon />
                      </ListItemIcon>
                      <ListItemText primary="Users" />
                      </ListItemButton>
                    </ListItem>
                  </Link>
                ) : null}
                {user?.roles.includes(UserRoles.config) ? (
                  <Link
                    to="/cfg"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    <ListItem>
                    <ListItemButton>
                      <ListItemIcon>
                        <SettingsIcon />
                      </ListItemIcon>
                      <ListItemText primary="Config" />
                      </ListItemButton>
                    </ListItem>
                  </Link>
                ) : null}
                {user?.roles.includes(UserRoles.firmware) ? (
                  <Link
                    to="/decoderring"
                    style={{ color: "white", textDecoration: "none" }}
                  >
                    <ListItem>
                    <ListItemButton>
                      <ListItemIcon>
                        <DeblurIcon />
                      </ListItemIcon>
                      <ListItemText primary="Decorder Ring" />
                      </ListItemButton>
                    </ListItem>
                  </Link>
                ) : null}
              </div>
            </List>
          ) : null}
        </Drawer>
      ) : null}
    </Fragment>
  );
}
